import Login from '../../components/auth/Login.vue';
import Activation from '../../components/auth/Activation.vue';
import ResetPasswordConfirm from '../../components/auth/ResetPasswordConfirm.vue';
import ResetPassword from '../../components/auth/ResetPassword.vue';
import Logout from '../../components/auth/Logout.vue';

import { isNotAuthenticated } from '../guards/auth';

export default [
  {
    path: '/prihlaseni',
    name: 'login',
    component: Login,
    meta: { layout: 'blank' },
    beforeEnter: isNotAuthenticated,
  },
  {
    path: '/activation/:token',
    name: 'activation',
    component: Activation,
    meta: { layout: 'blank' },
    beforeEnter: isNotAuthenticated,
  },
  {
    path: '/reset-password-confirm/:token',
    name: 'reset-password-confirm',
    component: ResetPasswordConfirm,
    meta: { layout: 'blank' },
    beforeEnter: isNotAuthenticated,
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword,
    meta: { layout: 'blank' },
    beforeEnter: isNotAuthenticated,
  },
  {
    path: '/odhlaseni',
    name: 'logout',
    component: Logout,
  },
];
